import { render, staticRenderFns } from "./B-2-1g__NavigationEdit_Support-Nav.vue?vue&type=template&id=99364396&"
import script from "./B-2-1g__NavigationEdit_Support-Nav.vue?vue&type=script&lang=js&"
export * from "./B-2-1g__NavigationEdit_Support-Nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports